import { useHistory } from "react-router-dom";
import { useRecoilState } from "recoil";
import { myLeaveApproveLeaveRequestsPageRoutePath } from "my-leave/configs/routes";
import { useMyLeaveBadges } from "my-leave/hooks";
import { useOcIsMobile } from "oc/hooks";
import { ocNarrowMenuState } from "states";

export const useMyLeaveHeaderBadge = (): {
  handleClick: () => void;
  count: number;
} => {
  const history = useHistory();
  const isMobile = useOcIsMobile();
  const [narrowMenuOpened, setNarrowMenuOpened] =
    useRecoilState(ocNarrowMenuState);

  const { data } = useMyLeaveBadges();

  const count = data?.allLeaveRequestsCount ?? 0;
  const handleClick = () => {
    if (isMobile) {
      setNarrowMenuOpened(!narrowMenuOpened);
    }

    history.push(myLeaveApproveLeaveRequestsPageRoutePath);
  };

  return {
    handleClick,
    count,
  };
};
